import { authMode } from "@/data/authMode";
import { useLogOutMutation } from "@/data/queries";
import { redirectToAuthAppLogin, restoreSession } from "@/data/requests";
import { useAuthSessionAtom } from "@/data/store";
import { isRefreshTokenExpired } from "@/model/AuthSession";
import { PropsWithChildren, useEffect } from "react";
import { useNavigate } from "react-router";

const Auth = ({ children }: PropsWithChildren) => {
  const [authSession] = useAuthSessionAtom();
  const navigate = useNavigate();
  const { mutate: logOut, isPending: isLoggingOut } = useLogOutMutation();

  useEffect(() => {
    if (authSession && isRefreshTokenExpired(authSession)) {
      logOut({}); // Sets authSession to null
    }
    if (authSession) {
      return;
    }
    if (authMode === "bearer") {
      navigate("/login");
      return;
    }
    restoreSession().then((restored) => {
      if (!restored) {
        redirectToAuthAppLogin();
      }
    });
  }, [authSession, navigate, logOut]);

  if (!authSession || isLoggingOut) {
    return null;
  }

  return children;
};

export default Auth;
